export const MENU_IDS = Object.freeze({
    ALL_PROJECTS: {
        OVERVIEW: {
            DEFAULT: 'MASTHEAD.OVERVIEW',
            DASHBOARD: 'MASTHEAD.OVERVIEW.DASHBOARD',
            PROJECTS: 'MASTHEAD.OVERVIEW.PROJECTS',
            RELEASE: 'MASTHEAD.OVERVIEW.RELEASE',
            SYSTEM: 'MASTHEAD.OVERVIEW.SYSTEM'
        },
        PORTFOLIO: 'MASTHEAD.PORTFOLIO',
        DEFECTS: 'MASTHEAD.DEFECTS'
    },
    SETTINGS: {
        CONFIGURATION: 'SETTINGS.CONFIGURATION',
        CODE_BOX: 'SETTINGS.CODEBOX',
        USERS: 'SETTINGS.USERS',
        USER_GROUPS: 'SETTING.GROUPS',
        ROLES: 'SETTINGS.ROLES_MANAGEMENT'
    },
    SYSTEM: {
        ORGANIZATION_OVERVIEW: 'SYSTEM.ORGANIZATION_OVERVIEW',
        PROJECT: 'SYSTEM.PROJECT',
        NEW_ANALYSIS: 'SYSTEM.NEW_ANALYSIS',
        TEST_ASSETS: 'SYSTEM.TEST_ASSETS',
        SNAPSHOT: 'SYSTEM.SNAPSHOT',
        FITNESS: 'SYSTEM.FITNESS',
        SATELLITE: 'SYSTEM.SATELLITE'
    },
    RELEASE: {
        OVERVIEW: {
            DEFAULT: 'RELEASE.OVERVIEW',
            RISK_COCKPIT: 'RELEASE.OVERVIEW.RISK_COCKPIT',
            RELEASE_OVERVIEW: 'RELEASE.OVERVIEW.RELEASE_OVERVIEW',
            RELEASE_DETAILS: 'RELEASE.OVERVIEW.RELEASE_DETAILS'
        },
        REQUIREMENTS: 'RELEASE.REQUIREMENTS',
        REPORTS: 'RELEASE.REPORTS'
    },
    PROJECT: {
        OVERVIEW: {
            DEFAULT: 'PROJECT.OVERVIEW',
            ORG_OVERVIEW: 'PROJECT.OVERVIEW.ORG_OVERVIEW',
            CUSTOM_DASHBOARD: 'PROJECT.OVERVIEW.CUSTOM_DASHBOARD',
            PROJECT_DASHBOARD: 'PROJECT.OVERVIEW.PROJECT_DASHBOARD',
            CORRECTION_PLAN: 'PROJECT.OVERVIEW.CORRECTION_PLAN',
            SF_COMPONENTS_LIST: 'PROJECT.OVERVIEW.SF_COMPONENTS_LIST',
            AUTOMATION_COMPONENTS: 'PROJECT.OVERVIEW.AUTOMATION_COMPONENTS',
            SF_WORKFLOW_EMAIL_ALERT: 'PROJECT.OVERVIEW.SF_WORKFLOW_EMAIL_ALERT',
            POTENTIAL_TECHNICAL_DEBT: 'PROJECT.OVERVIEW.POTENTIAL_TECHNICAL_DEBT',
            SUPPORT_PACKAGES: 'PROJECT.OVERVIEW.SUPPORT_PACKAGES',
            SAP_NOTES: 'PROJECT.OVERVIEW.SAP_NOTES',
            CHANGED_CONTENT: 'PROJECT.OVERVIEW.CHANGED_CONTENT',
            SATELLITE_OVERVIEW: 'PROJECT.OVERVIEW.SATELLITE_OVERVIEW',
            PROJECT_DETAILS: 'PROJECT.OVERVIEW.PROJECT_DETAILS',
            PROJECT_PLAN: 'PROJECT.OVERVIEW.PROJECT_PLAN'
        },
        DEV_ENTITY: {
            REQUIREMENTS: 'PROJECT.DEV_ENTITY.REQUIREMENTS',
            ALL_REQUIREMENTS: 'PROJECT.DEV_ENTITY.ALL_REQUIREMENTS',
            AGILE_BOARD: 'PROJECT.DEV_ENTITY.AGILE_BOARD',
            PLANNING_BOARD: 'PROJECT.DEV_ENTITY.PLANNING_BOARD',
            DEVELOPMENT: 'PROJECT.DEV_ENTITY.DEVELOPMENT',
            ALL_DEVELOPMENT: 'PROJECT.DEV_ENTITY.ALL_DEVELOPMENT',
            WORKSTREAMS: 'PROJECT.DEV_ENTITY.WORKSTREAMS'
        },
        TESTS: {
            DEFAULT: 'PROJECT.EXECUTION',
            TEST_TREE: 'PROJECT.TESTS.TEST_TREE',
            TEST_LIST: 'PROJECT.TESTS.TEST_LIST',
            STEP_LIST: 'PROJECT.TESTS.STEP_LIST',
            TEST_SET_LIST: 'PROJECT.TESTS.TEST_SET_LIST',
            AUTOMATION_SUB: 'PROJECT.TESTS.AUTOMATION_SUB',
            PA_EXECUTION_SCHEDULING: 'PROJECT.TESTS.PA_EXECUTION_SCHEDULING',
            PA_EXECUTION_LIST: 'PROJECT.TESTS.PA_EXECUTION_LIST',
            PLAYLIST_EXECUTION: 'PROJECT.TESTS.PLAYLIST_EXECUTION',
            TEST_BOX: 'PROJECT.TESTS.TEST_BOX',
            PA_RUN: 'PROJECT.TESTS.PA_RUN'
        },
        DEFECTS: {
            DEFAULT: 'PROJECT.DEFECTS',
            SITE_WIDE_DEFECTS: 'PROJECT.SITE_WIDE_DEFECTS'
        },
        CORRECTIONS: {
            DEFAULT: 'PROJECT.CORRECTIONS',
            CORRECTION_PLAN: 'PROJECT.CORRECTIONS.CORRECTION_PLAN',
            ISSUES: 'PROJECT.CORRECTIONS.ISSUES'
        },
        REPORTS: 'PROJECT.REPORTS',
        DISCOVERY: 'PROJECT.DISCOVERY'
    }
});
